"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Article = exports.ARTICLE_DATETIMES = exports.ARTICLE_ON_UPDATE_IGNORE_PROPS = exports.ARTICLE_STORY_ASSETS_FIELDS = exports.ARTICLE_ASSETS_FIELDS = exports.ARTICLE_BOOLEANS = exports.ARTICLE_INTEGERS = exports.ARTICLE_MODEL_VERSION = exports.ARTICLE_TYPES = void 0;
const moment = require("moment");
const QuizData_1 = require("./QuizData");
const StoryData_1 = require("./StoryData");
const SharingData_1 = require("./SharingData");
const TagData_1 = require("./TagData");
const AutoPublishOptions_1 = require("./AutoPublishOptions");
const uniqid = require("uniqid");
exports.ARTICLE_TYPES = ["post", "search", "story", "quiz", "tool", "video"];
exports.ARTICLE_MODEL_VERSION = "latest";
exports.ARTICLE_INTEGERS = [
    "weight", "maxViews",
];
exports.ARTICLE_BOOLEANS = [
    "isFree", "published", "archived", "showReadMore", "isVideo", "promoteInSearch", "isPinned"
];
exports.ARTICLE_ASSETS_FIELDS = [
    "logo", "image", "imageSmall",
];
exports.ARTICLE_STORY_ASSETS_FIELDS = [
    "story.screens[%d].logo", "story.screens[%d].image",
];
exports.ARTICLE_ON_UPDATE_IGNORE_PROPS = [
    "id", "label", "_$audiences", "_$map",
];
exports.ARTICLE_DATETIMES = [
    "createdAt", "publishedAt", "unpublishedAt", "autoStartAt", "autoStopAt",
];
const imageFields = [
    "logo",
    "image",
    "video"
];
class Article {
    constructor(data) {
        this.id = null;
        this.name = null;
        this.label = 'Article';
        this.type = null;
        this.maxViews = 5;
        this.isFree = false;
        this.isSeen = false;
        this.published = false;
        this.archived = false;
        this.showReadMore = true;
        this.openIn = null;
        this.isPinned = false;
        this.createdAt = null;
        this.updatedAt = null;
        this.publishedAt = null;
        this.unpublishedAt = null;
        this.autoStartAt = null;
        this.autoStopAt = null;
        this.quiz = new QuizData_1.QuizData();
        this.story = new StoryData_1.StoryData();
        this.sharing = new SharingData_1.SharingData();
        this.logo = 'https://med-cdn.ams3.digitaloceanspaces.com/assets/clients/medics_assets/pastille.png';
        this.image = null;
        this.images = [];
        this.video = null;
        this.source = 'https://360medics.com/';
        this.author = null;
        this.title = null;
        this.subtitle = null;
        this.tagline = null;
        this.description = null;
        this.footNote = "Vos données sont protégées. Aucune donnée nominative n’est partagée avec le partenaire.";
        this.buttonLabel = "Découvrir";
        this._$audiences = [];
        this._$pinnedArticles = [];
        this.autoPublishOptions = new AutoPublishOptions_1.AutoPublishOptions();
        this.tag = new TagData_1.TagData();
        if (data) {
            if (Object.keys(data).length === 0) {
                throw new Error(`Article.ts: data is provided but is an empty object. Did you try to hydray with empty req.body object?`);
            }
            this.hydrate(data);
            if (typeof data.audiences !== "undefined" && data.audiences !== null) {
                this._$audiences = data.audiences;
            }
            if (typeof data.pinnedArticles !== "undefined" && data.pinnedArticles !== null) {
                this._$pinnedArticles = data.pinnedArticles;
            }
        }
    }
    hydrate(data) {
        for (const prop in data) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                if (prop === 'quiz') {
                    this['quiz'] = new QuizData_1.QuizData(data[prop]);
                    if (typeof data.hasAnswered !== "undefined" && typeof data.answeredIds !== "undefined") {
                        this['quiz'].hasAnswered = data.hasAnswered;
                        if (null !== data.answeredIds) {
                            this['quiz'].answeredIds = data.answeredIds.split(";");
                        }
                        else {
                            this['quiz'].answeredIds = [];
                        }
                    }
                }
                else if (prop === 'story') {
                    this['story'] = new StoryData_1.StoryData(data[prop]);
                    this['story'].isSeen = data.isSeen;
                }
                else if (prop === 'sharing') {
                    this['sharing'] = new SharingData_1.SharingData(data[prop]);
                }
                else if (prop === 'autoPublishOptions') {
                    this['autoPublishOptions'] = new AutoPublishOptions_1.AutoPublishOptions(data[prop]);
                }
                else if (prop === 'tag') {
                    this['tag'] = new TagData_1.TagData(data[prop]);
                }
                else if (exports.ARTICLE_DATETIMES.indexOf(prop) > -1) {
                    if (typeof data[prop] === "number") {
                        this[prop] = parseInt(`${data[prop]}`);
                    }
                    else {
                        try {
                            const datetime = moment(data[prop]);
                            if (!datetime.isValid()) {
                                this[prop] = null;
                            }
                            else {
                                this[prop] = (datetime.valueOf() / 1000);
                            }
                        }
                        catch (e) {
                            this[prop] = null;
                        }
                    }
                }
                else if (prop === 'images') {
                    if (!data[prop]) {
                        this[prop] = [];
                    }
                    else {
                        this[prop] = typeof data[prop] === "string"
                            ? JSON.parse(data[prop]).map(image => `${image.split('?d=')[0]}?d=${uniqid()}`)
                            : data[prop].map(image => `${image.split('?d=')[0]}?d=${uniqid()}`);
                    }
                }
                else if (imageFields.includes(prop)) {
                    let value = data[prop] ? `${data[prop].split('?d=')[0]}?d=${uniqid()}` : null;
                    this[prop] = value;
                    if (prop === 'logo' && data.type === "notification" && !data.logo) {
                        this.logo = null;
                    }
                }
                else {
                    let value = data[prop];
                    if (exports.ARTICLE_INTEGERS.indexOf(prop) > -1) {
                        value = parseInt(value);
                    }
                    if (exports.ARTICLE_BOOLEANS.indexOf(prop) > -1) {
                        value = Article.toBoolOrNull(value);
                    }
                    this[prop] = value;
                }
            }
        }
    }
    setUpdatedAt(value = null) {
        if (null === value) {
            this.updatedAt = Math.round(moment().valueOf() / 1000);
        }
        else {
            if (`${value}`.length === 10) {
                this.updatedAt = value;
            }
            else {
                throw new Error("Article::setupdatedAt(<timestamp>) must be an epoch timestamp with 10 numbers. This feature will break in 2480");
            }
        }
    }
    static toBoolOrNull(value) {
        if (value === null) {
            return null;
        }
        switch (`${value}`.toLowerCase().trim()) {
            case "true":
            case "yes":
            case "1": return true;
            case "false":
            case "no":
            case "0":
            case null: return false;
            default: return Boolean(value);
        }
    }
}
exports.Article = Article;
Article.NOW = null;
//# sourceMappingURL=Article.js.map